import * as React from 'react';

import { DimeSkeleton } from '../DimeSkeleton.js';
import { DimeTableCell } from './DimeTableCell.js';
import { DimeTableRow } from './DimeTableRow.js';

export function SkeletonRows({
  rowCount,
  columnCount,
}: Readonly<{ rowCount: number; columnCount: number }>) {
  return Array.from({ length: rowCount }).map((_, rowIndex) => (
    <DimeTableRow key={`skeleton-${rowIndex}`}>
      {Array.from({ length: columnCount }).map((_, colIndex) => (
        <DimeTableCell key={`skeleton-${rowIndex}-${colIndex}`}>
          <DimeSkeleton className="h-4 w-full" />
        </DimeTableCell>
      ))}
    </DimeTableRow>
  ));
}
